export default "__VITE_ASSET__kkbknb4h__";